// import React from "react";
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import HighchartsMore from "highcharts/highcharts-more";
// import Drilldown from "highcharts/modules/drilldown";

// HighchartsMore(Highcharts);
// Drilldown(Highcharts);

// const CarbonEmissionsChart = () => {
//   const manualData = {
//     "Category III Codes": {
//       "Prostate Ablation Procedure": {
//         "Anthem Participating Network": 272.95,
//         "BC ID Blue Value POS Network": 333.09,
//         "BC ID Preferred Blue Network": 333.09,
//         "BC ID Preferred Blue PPO Network": 294.65,
//       },
//       "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
//         "Anthem Participating Network": 147.22,
//         "BC ID Blue Value POS Network": 147.22,
//         "BC ID Preferred Blue Network": 147.22,
//         "BC ID Preferred Blue PPO Network": 147.22,
//       },
//       "Laser Ablation Procedures": {
//         "Anthem Participating Network": 605.01,
//         "BC ID Blue Value POS Network": 605.01,
//         "BC ID Preferred Blue Network": 605.01,
//         "BC ID Preferred Blue PPO Network": 605.01,
//       },
//       "Stereotactic Intracranial Lesion Ablation Procedure": {
//         "Anthem Participating Network": 338.44,
//         "BC ID Blue Value POS Network": 298.36,
//         "BC ID Preferred Blue Network": 298.36,
//         "BC ID Preferred Blue PPO Network": 338.44,
//       },
//       "Transnasal EGD and Capsule Endoscopy Procedures": {
//         "Anthem Participating Network": 584.68,
//         "BC ID Blue Value POS Network": 584.68,
//         "BC ID Preferred Blue Network": 584.68,
//         "BC ID Preferred Blue PPO Network": 584.68,
//       },
//       "Carotid Sinus Baroreflex Activation Device Procedures": {
//         "Anthem Participating Network": 278.66,
//         "BC ID Blue Value POS Network": "Unavailable",
//         "BC ID Preferred Blue Network": "Unavailable",
//         "BC ID Preferred Blue PPO Network": 278.66,
//       },
//       "Imaging, Testing, Implantation and Other Services": {
//         "Anthem Participating Network": 619.55,
//         "BC ID Blue Value POS Network": 619.55,
//         "BC ID Preferred Blue Network": 619.55,
//         "BC ID Preferred Blue PPO Network": 619.55,
//       },
//       "Insertion of Aqueous Drainage Device": {
//         "Anthem Participating Network": 207.97,
//         "BC ID Blue Value POS Network": "Unavailable",
//         "BC ID Preferred Blue Network": "Unavailable",
//         "BC ID Preferred Blue PPO Network": 207.97,
//       },
//       "Intracardiac Ischemia Monitoring Procedures": {
//         "Anthem Participating Network": 153.86,
//         "BC ID Blue Value POS Network": 153.86,
//         "BC ID Preferred Blue Network": 153.86,
//         "BC ID Preferred Blue PPO Network": 153.86,
//       },
//       "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
//         "Anthem Participating Network": 178.15,
//         "BC ID Blue Value POS Network": 178.15,
//         "BC ID Preferred Blue Network": 178.15,
//         "BC ID Preferred Blue PPO Network": 178.15,
//       },
//     },
//     "Chemotherapy Drugs": {
//       "Chemotherapy Drugs": {
//         "Anthem Participating Network": 250.98,
//         "BC ID Blue Value POS Network": 243.03,
//         "BC ID Preferred Blue Network": 243.03,
//         "BC ID Preferred Blue PPO Network": 242.29,
//       },
//     },
//     "Drugs Administered Other than Oral Method": {
//       "Drugs, Administered by Injection": {
//         "Anthem Participating Network": 260.7,
//         "BC ID Blue Value POS Network": 247.36,
//         "BC ID Preferred Blue Network": 247.36,
//         "BC ID Preferred Blue PPO Network": 252.38,
//       },
//       "Miscellaneous Drugs": {
//         "Anthem Participating Network": 234.78,
//         "BC ID Blue Value POS Network": 239.27,
//         "BC ID Preferred Blue Network": 239.27,
//         "BC ID Preferred Blue PPO Network": 235.47,
//       },
//       "Clotting Factors": {
//         "Anthem Participating Network": 227.49,
//         "BC ID Blue Value POS Network": 215.47,
//         "BC ID Preferred Blue Network": 215.47,
//         "BC ID Preferred Blue PPO Network": 214.66,
//       },
//       "Chemotherapy Drugs, Oral Administration": {
//         "Anthem Participating Network": 241.13,
//         "BC ID Blue Value POS Network": "Unavailable",
//         "BC ID Preferred Blue Network": "Unavailable",
//         "BC ID Preferred Blue PPO Network": 241.13,
//       },
//       "Immunosuppressive Drugs": {
//         "Anthem Participating Network": 188.53,
//         "BC ID Blue Value POS Network": 188.53,
//         "BC ID Preferred Blue Network": 188.53,
//         "BC ID Preferred Blue PPO Network": 188.53,
//       },
//     },
//     "Evaluation and Management": {
//       "Preventive Medicine Services": {
//         "Anthem Participating Network": 298.53,
//         "BC ID Blue Value POS Network": 288.5,
//         "BC ID Preferred Blue Network": 288.5,
//         "BC ID Preferred Blue PPO Network": 312.29,
//       },
//       "Transitional Care Management Services": {
//         "Anthem Participating Network": 309.17,
//         "BC ID Blue Value POS Network": 314.26,
//         "BC ID Preferred Blue Network": 314.26,
//         "BC ID Preferred Blue PPO Network": 322.86,
//       },
//       "Psychiatric Collaborative Care Management Services": {
//         "Anthem Participating Network": 293.26,
//         "BC ID Blue Value POS Network": 213.38,
//         "BC ID Preferred Blue Network": 213.38,
//         "BC ID Preferred Blue PPO Network": 293.26,
//       },
//       "Care Management Services": {
//         "Anthem Participating Network": 204.65,
//         "BC ID Blue Value POS Network": 204.65,
//         "BC ID Preferred Blue Network": 204.65,
//         "BC ID Preferred Blue PPO Network": 204.65,
//       },
//       "Newborn Care Services": {
//         "Anthem Participating Network": 389.88,
//         "BC ID Blue Value POS Network": 389.88,
//         "BC ID Preferred Blue Network": 389.88,
//         "BC ID Preferred Blue PPO Network": 389.88,
//       },
//       "Delivery/Birthing Room Attendance and Resuscitation Services": {
//         "Anthem Participating Network": 209.07,
//         "BC ID Blue Value POS Network": 209.07,
//         "BC ID Preferred Blue Network": 209.07,
//         "BC ID Preferred Blue PPO Network": 209.07,
//       },
//     },
//     "Medicine Services and Procedures": {
//       "Cardiovascular Procedures": {
//         "Anthem Participating Network": 360.68,
//         "BC ID Blue Value POS Network": 339.42,
//         "BC ID Preferred Blue Network": 339.42,
//         "BC ID Preferred Blue PPO Network": 359.71,
//       },
//     },
//   };

//   const categories = Object.keys(manualData).map((category) => ({
//     name: category,
//     value: Object.keys(manualData[category]).length,
//     drilldown: category,
//   }));

//   const subCategoryDrilldowns = Object.keys(manualData).map((category) => ({
//     id: category,
//     name: `${category} Subcategories`,
//     type: "packedbubble",
//     data: Object.keys(manualData[category]).map((subCategory) => ({
//       name: subCategory,
//       value: Object.values(manualData[category][subCategory]).reduce(
//         (a, b) => a + b,
//         0
//       ),
//       drilldown: `${subCategory}-drilldown`,
//     })),
//   }));

//   const networkDrilldowns = Object.keys(manualData).flatMap((category) =>
//     Object.keys(manualData[category]).map((subCategory) => ({
//       id: `${subCategory}-drilldown`,
//       name: `${subCategory} Breakdown`,
//       type: "column",
//       data: Object.entries(manualData[category][subCategory]).map(
//         ([network, value]) => [network, value]
//       ),
//     }))
//   );

//   // Dynamically extract network names from data
//   const networkCategories = [
//     ...new Set(
//       Object.values(manualData).flatMap((category) =>
//         Object.values(category).flatMap((subCategory) =>
//           Object.keys(subCategory)
//         )
//       )
//     ),
//   ];

//   const options = {
//     chart: {
//       type: "packedbubble",
//     },
//     title: {
//       text: "Network Comparison: % of Medicare",
//     },
//     plotOptions: {
//       packedbubble: {
//         minSize: "10%",
//         maxSize: "100%",
//         dataLabels: {
//           enabled: true,
//           format: "{point.name}",
//         },
//       },
//     },
//     series: [
//       {
//         name: "Categories",
//         data: categories,
//       },
//     ],
//     drilldown: {
//       series: [...subCategoryDrilldowns, ...networkDrilldowns],
//     },
//     xAxis: {
//       categories: networkCategories, // Now dynamically populated
//     },
//   };

//   return <HighchartsReact highcharts={Highcharts} options={options} />;
// };

// export default CarbonEmissionsChart;

// import React, { useState } from "react";
// import Highcharts from "highcharts/highstock";
// import HighchartsReact from "highcharts-react-official";
// import highchartsMore from "highcharts/highcharts-more";
// import "./DrillDownComponent.css";

// highchartsMore(Highcharts);
// const manualData = {
//   "Category III Codes": {
//     "Prostate Ablation Procedure": {
//       "Anthem Participating Network": 272.95,
//       "BC ID Blue Value POS Network": 333.09,
//       "BC ID Preferred Blue Network": 333.09,
//       "BC ID Preferred Blue PPO Network": 294.65,
//     },
//     "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
//       "Anthem Participating Network": 147.22,
//       "BC ID Blue Value POS Network": 147.22,
//       "BC ID Preferred Blue Network": 147.22,
//       "BC ID Preferred Blue PPO Network": 147.22,
//     },
//     "Laser Ablation Procedures": {
//       "Anthem Participating Network": 605.01,
//       "BC ID Blue Value POS Network": 605.01,
//       "BC ID Preferred Blue Network": 605.01,
//       "BC ID Preferred Blue PPO Network": 605.01,
//     },
//     "Stereotactic Intracranial Lesion Ablation Procedure": {
//       "Anthem Participating Network": 338.44,
//       "BC ID Blue Value POS Network": 298.36,
//       "BC ID Preferred Blue Network": 298.36,
//       "BC ID Preferred Blue PPO Network": 338.44,
//     },
//     "Transnasal EGD and Capsule Endoscopy Procedures": {
//       "Anthem Participating Network": 584.68,
//       "BC ID Blue Value POS Network": 584.68,
//       "BC ID Preferred Blue Network": 584.68,
//       "BC ID Preferred Blue PPO Network": 584.68,
//     },
//     "Carotid Sinus Baroreflex Activation Device Procedures": {
//       "Anthem Participating Network": 278.66,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 278.66,
//     },
//     "Imaging, Testing, Implantation and Other Services": {
//       "Anthem Participating Network": 619.55,
//       "BC ID Blue Value POS Network": 619.55,
//       "BC ID Preferred Blue Network": 619.55,
//       "BC ID Preferred Blue PPO Network": 619.55,
//     },
//     "Insertion of Aqueous Drainage Device": {
//       "Anthem Participating Network": 207.97,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 207.97,
//     },
//     "Intracardiac Ischemia Monitoring Procedures": {
//       "Anthem Participating Network": 153.86,
//       "BC ID Blue Value POS Network": 153.86,
//       "BC ID Preferred Blue Network": 153.86,
//       "BC ID Preferred Blue PPO Network": 153.86,
//     },
//     "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
//       "Anthem Participating Network": 178.15,
//       "BC ID Blue Value POS Network": 178.15,
//       "BC ID Preferred Blue Network": 178.15,
//       "BC ID Preferred Blue PPO Network": 178.15,
//     },
//   },
//   "Chemotherapy Drugs": {
//     "Chemotherapy Drugs": {
//       "Anthem Participating Network": 250.98,
//       "BC ID Blue Value POS Network": 243.03,
//       "BC ID Preferred Blue Network": 243.03,
//       "BC ID Preferred Blue PPO Network": 242.29,
//     },
//   },
//   "Drugs Administered Other than Oral Method": {
//     "Drugs, Administered by Injection": {
//       "Anthem Participating Network": 260.7,
//       "BC ID Blue Value POS Network": 247.36,
//       "BC ID Preferred Blue Network": 247.36,
//       "BC ID Preferred Blue PPO Network": 252.38,
//     },
//     "Miscellaneous Drugs": {
//       "Anthem Participating Network": 234.78,
//       "BC ID Blue Value POS Network": 239.27,
//       "BC ID Preferred Blue Network": 239.27,
//       "BC ID Preferred Blue PPO Network": 235.47,
//     },
//     "Clotting Factors": {
//       "Anthem Participating Network": 227.49,
//       "BC ID Blue Value POS Network": 215.47,
//       "BC ID Preferred Blue Network": 215.47,
//       "BC ID Preferred Blue PPO Network": 214.66,
//     },
//     "Chemotherapy Drugs, Oral Administration": {
//       "Anthem Participating Network": 241.13,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 241.13,
//     },
//     "Immunosuppressive Drugs": {
//       "Anthem Participating Network": 188.53,
//       "BC ID Blue Value POS Network": 188.53,
//       "BC ID Preferred Blue Network": 188.53,
//       "BC ID Preferred Blue PPO Network": 188.53,
//     },
//   },
//   "Evaluation and Management": {
//     "Preventive Medicine Services": {
//       "Anthem Participating Network": 298.53,
//       "BC ID Blue Value POS Network": 288.5,
//       "BC ID Preferred Blue Network": 288.5,
//       "BC ID Preferred Blue PPO Network": 312.29,
//     },
//     "Transitional Care Management Services": {
//       "Anthem Participating Network": 309.17,
//       "BC ID Blue Value POS Network": 314.26,
//       "BC ID Preferred Blue Network": 314.26,
//       "BC ID Preferred Blue PPO Network": 322.86,
//     },
//     "Psychiatric Collaborative Care Management Services": {
//       "Anthem Participating Network": 293.26,
//       "BC ID Blue Value POS Network": 213.38,
//       "BC ID Preferred Blue Network": 213.38,
//       "BC ID Preferred Blue PPO Network": 293.26,
//     },
//     "Care Management Services": {
//       "Anthem Participating Network": 204.65,
//       "BC ID Blue Value POS Network": 204.65,
//       "BC ID Preferred Blue Network": 204.65,
//       "BC ID Preferred Blue PPO Network": 204.65,
//     },
//     "Newborn Care Services": {
//       "Anthem Participating Network": 389.88,
//       "BC ID Blue Value POS Network": 389.88,
//       "BC ID Preferred Blue Network": 389.88,
//       "BC ID Preferred Blue PPO Network": 389.88,
//     },
//     "Delivery/Birthing Room Attendance and Resuscitation Services": {
//       "Anthem Participating Network": 209.07,
//       "BC ID Blue Value POS Network": 209.07,
//       "BC ID Preferred Blue Network": 209.07,
//       "BC ID Preferred Blue PPO Network": 209.07,
//     },
//   },
//   "Medicine Services and Procedures": {
//     "Cardiovascular Procedures": {
//       "Anthem Participating Network": 360.68,
//       "BC ID Blue Value POS Network": 339.42,
//       "BC ID Preferred Blue Network": 339.42,
//       "BC ID Preferred Blue PPO Network": 359.71,
//     },
//   },
// };
// const DrillDownComponent = () => {
//   const [level, setLevel] = useState(0);
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [selectedSubcategory, setSelectedSubcategory] = useState(null);

//   const breadcrumbs = [
//     { label: " Home", level: 0, action: () => resetNavigation() },
//     ...(selectedCategory
//       ? [
//           {
//             label: ` ${selectedCategory}`,
//             level: 1,
//             action: () => goToCategory(selectedCategory),
//           },
//         ]
//       : []),
//     ...(selectedSubcategory
//       ? [
//           {
//             label: ` ${selectedSubcategory}`,
//             level: 2,
//             action: () => goToSubcategory(selectedSubcategory),
//           },
//         ]
//       : []),
//   ];

//   const resetNavigation = () => {
//     setLevel(0);
//     setSelectedCategory(null);
//     setSelectedSubcategory(null);
//   };

//   const goToCategory = (category) => {
//     setLevel(1);
//     setSelectedCategory(category);
//     setSelectedSubcategory(null);
//   };

//   const goToSubcategory = (subcategory) => {
//     setLevel(2);
//     setSelectedSubcategory(subcategory);
//   };

//   const getChartOptions = () => {
//     const data = Object.entries(
//       manualData[selectedCategory]?.[selectedSubcategory] || {}
//     ).map(([network, price]) => ({
//       name: network,
//       value: typeof price === "number" ? price : null,
//     }));

//     return {
//       chart: { type: "packedbubble", height: "40%" },
//       title: {
//         text: "Categories Comparison: % of Medicare",
//         align: "center",
//         style: {
//           fontSize: "20px",
//           fontWeight: "bold",
//           fontFamily: "'Montserrat', serif",
//         },
//       },
//       tooltip: {
//         useHTML: true,
//         pointFormat: "<b>{point.name}</b>: ${point.value || 'Unavailable'}",
//       },
//       plotOptions: {
//         packedbubble: {
//           minSize: "30%",
//           maxSize: "100%",
//           layoutAlgorithm: { splitSeries: false, gravitationalConstant: 0.02 },
//           dataLabels: {
//             enabled: true,
//             format: "{point.name}",
//             style: { fontWeight: "bold", color: "black" },
//           },
//         },
//       },
//       series: [
//         {
//           name: "% of Medicare",
//           data,
//           colorByPoint: true,
//         },
//       ],
//       colors: ["#C1E7E7", "#4F7A8A", "#D1E8FF", "#FFD2A0"],
//     };
//   };

//   return (
//     <div className="container">
//       <nav className="breadcrumbs">
//         <ul className="breadcrumbs-list">
//           {breadcrumbs.map((crumb, index) => (
//             <li key={index} className="breadcrumb-item">
//               <button
//                 className={`breadcrumb-button ${
//                   level === crumb.level ? "active" : "hover"
//                 }`}
//                 onClick={crumb.action}
//               >
//                 {crumb.label}
//               </button>
//               {index < breadcrumbs.length - 1 && (
//                 <span className="breadcrumb-separator">/</span>
//               )}
//             </li>
//           ))}
//         </ul>
//       </nav>
//       <div className="content-card">
//         {level === 0 && (
//           <div>
//             <h2 className="title">Select a Category</h2>
//             <ul className="category-list">
//               {Object.keys(manualData).map((category, index) => (
//                 <li key={index}>
//                   <button
//                     className="category-button"
//                     onClick={() => goToCategory(category)}
//                   >
//                     {category}
//                   </button>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         )}
//         {level === 1 && selectedCategory && (
//           <div>
//             <h2 className="title">{selectedCategory}</h2>
//             <ul className="subcategory-list">
//               {Object.keys(manualData[selectedCategory]).map(
//                 (subcategory, index) => (
//                   <li key={index}>
//                     <button
//                       className="subcategory-button"
//                       onClick={() => goToSubcategory(subcategory)}
//                     >
//                       {subcategory}
//                     </button>
//                   </li>
//                 )
//               )}
//             </ul>
//           </div>
//         )}
//         {level === 2 && selectedSubcategory && selectedCategory && (
//           <div>
//             <h2 className="title">{selectedSubcategory}</h2>
//             <div className="chart-container">
//               <HighchartsReact
//                 highcharts={Highcharts}
//                 options={getChartOptions()}
//               />
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default DrillDownComponent;

// import React, { useState } from "react";
// import Highcharts from "highcharts/highstock";
// import HighchartsReact from "highcharts-react-official";
// import highchartsMore from "highcharts/highcharts-more";
// import "./DrillDownComponent.css";

// highchartsMore(Highcharts);
// const manualData = {
//   "Category III Codes": {
//     "Prostate Ablation Procedure": {
//       "Anthem Participating Network": 272.95,
//       "BC ID Blue Value POS Network": 333.09,
//       "BC ID Preferred Blue Network": 333.09,
//       "BC ID Preferred Blue PPO Network": 294.65,
//     },
//     "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
//       "Anthem Participating Network": 147.22,
//       "BC ID Blue Value POS Network": 147.22,
//       "BC ID Preferred Blue Network": 147.22,
//       "BC ID Preferred Blue PPO Network": 147.22,
//     },
//     "Laser Ablation Procedures": {
//       "Anthem Participating Network": 605.01,
//       "BC ID Blue Value POS Network": 605.01,
//       "BC ID Preferred Blue Network": 605.01,
//       "BC ID Preferred Blue PPO Network": 605.01,
//     },
//     "Stereotactic Intracranial Lesion Ablation Procedure": {
//       "Anthem Participating Network": 338.44,
//       "BC ID Blue Value POS Network": 298.36,
//       "BC ID Preferred Blue Network": 298.36,
//       "BC ID Preferred Blue PPO Network": 338.44,
//     },
//     "Transnasal EGD and Capsule Endoscopy Procedures": {
//       "Anthem Participating Network": 584.68,
//       "BC ID Blue Value POS Network": 584.68,
//       "BC ID Preferred Blue Network": 584.68,
//       "BC ID Preferred Blue PPO Network": 584.68,
//     },
//     "Carotid Sinus Baroreflex Activation Device Procedures": {
//       "Anthem Participating Network": 278.66,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 278.66,
//     },
//     "Imaging, Testing, Implantation and Other Services": {
//       "Anthem Participating Network": 619.55,
//       "BC ID Blue Value POS Network": 619.55,
//       "BC ID Preferred Blue Network": 619.55,
//       "BC ID Preferred Blue PPO Network": 619.55,
//     },
//     "Insertion of Aqueous Drainage Device": {
//       "Anthem Participating Network": 207.97,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 207.97,
//     },
//     "Intracardiac Ischemia Monitoring Procedures": {
//       "Anthem Participating Network": 153.86,
//       "BC ID Blue Value POS Network": 153.86,
//       "BC ID Preferred Blue Network": 153.86,
//       "BC ID Preferred Blue PPO Network": 153.86,
//     },
//     "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
//       "Anthem Participating Network": 178.15,
//       "BC ID Blue Value POS Network": 178.15,
//       "BC ID Preferred Blue Network": 178.15,
//       "BC ID Preferred Blue PPO Network": 178.15,
//     },
//   },
//   "Chemotherapy Drugs": {
//     "Chemotherapy Drugs": {
//       "Anthem Participating Network": 250.98,
//       "BC ID Blue Value POS Network": 243.03,
//       "BC ID Preferred Blue Network": 243.03,
//       "BC ID Preferred Blue PPO Network": 242.29,
//     },
//   },
//   "Drugs Administered Other than Oral Method": {
//     "Drugs, Administered by Injection": {
//       "Anthem Participating Network": 260.7,
//       "BC ID Blue Value POS Network": 247.36,
//       "BC ID Preferred Blue Network": 247.36,
//       "BC ID Preferred Blue PPO Network": 252.38,
//     },
//     "Miscellaneous Drugs": {
//       "Anthem Participating Network": 234.78,
//       "BC ID Blue Value POS Network": 239.27,
//       "BC ID Preferred Blue Network": 239.27,
//       "BC ID Preferred Blue PPO Network": 235.47,
//     },
//     "Clotting Factors": {
//       "Anthem Participating Network": 227.49,
//       "BC ID Blue Value POS Network": 215.47,
//       "BC ID Preferred Blue Network": 215.47,
//       "BC ID Preferred Blue PPO Network": 214.66,
//     },
//     "Chemotherapy Drugs, Oral Administration": {
//       "Anthem Participating Network": 241.13,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 241.13,
//     },
//     "Immunosuppressive Drugs": {
//       "Anthem Participating Network": 188.53,
//       "BC ID Blue Value POS Network": 188.53,
//       "BC ID Preferred Blue Network": 188.53,
//       "BC ID Preferred Blue PPO Network": 188.53,
//     },
//   },
//   "Evaluation and Management": {
//     "Preventive Medicine Services": {
//       "Anthem Participating Network": 298.53,
//       "BC ID Blue Value POS Network": 288.5,
//       "BC ID Preferred Blue Network": 288.5,
//       "BC ID Preferred Blue PPO Network": 312.29,
//     },
//     "Transitional Care Management Services": {
//       "Anthem Participating Network": 309.17,
//       "BC ID Blue Value POS Network": 314.26,
//       "BC ID Preferred Blue Network": 314.26,
//       "BC ID Preferred Blue PPO Network": 322.86,
//     },
//     "Psychiatric Collaborative Care Management Services": {
//       "Anthem Participating Network": 293.26,
//       "BC ID Blue Value POS Network": 213.38,
//       "BC ID Preferred Blue Network": 213.38,
//       "BC ID Preferred Blue PPO Network": 293.26,
//     },
//     "Care Management Services": {
//       "Anthem Participating Network": 204.65,
//       "BC ID Blue Value POS Network": 204.65,
//       "BC ID Preferred Blue Network": 204.65,
//       "BC ID Preferred Blue PPO Network": 204.65,
//     },
//     "Newborn Care Services": {
//       "Anthem Participating Network": 389.88,
//       "BC ID Blue Value POS Network": 389.88,
//       "BC ID Preferred Blue Network": 389.88,
//       "BC ID Preferred Blue PPO Network": 389.88,
//     },
//     "Delivery/Birthing Room Attendance and Resuscitation Services": {
//       "Anthem Participating Network": 209.07,
//       "BC ID Blue Value POS Network": 209.07,
//       "BC ID Preferred Blue Network": 209.07,
//       "BC ID Preferred Blue PPO Network": 209.07,
//     },
//   },
//   "Medicine Services and Procedures": {
//     "Cardiovascular Procedures": {
//       "Anthem Participating Network": 360.68,
//       "BC ID Blue Value POS Network": 339.42,
//       "BC ID Preferred Blue Network": 339.42,
//       "BC ID Preferred Blue PPO Network": 359.71,
//     },
//   },
// };
// const DrillDownComponent = () => {
//   const [level, setLevel] = useState(0);
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [selectedSubcategory, setSelectedSubcategory] = useState(null);

//   const breadcrumbs = [
//     { label: " Home", level: 0, action: () => resetNavigation() },
//     ...(selectedCategory
//       ? [
//           {
//             label: ` ${selectedCategory}`,
//             level: 1,
//             action: () => goToCategory(selectedCategory),
//           },
//         ]
//       : []),
//     ...(selectedSubcategory
//       ? [
//           {
//             label: ` ${selectedSubcategory}`,
//             level: 2,
//             action: () => goToSubcategory(selectedSubcategory),
//           },
//         ]
//       : []),
//   ];

//   const resetNavigation = () => {
//     setLevel(0);
//     setSelectedCategory(null);
//     setSelectedSubcategory(null);
//   };

//   const goToCategory = (category) => {
//     setLevel(1);
//     setSelectedCategory(category);
//     setSelectedSubcategory(null);
//   };

//   const goToSubcategory = (subcategory) => {
//     setLevel(2);
//     setSelectedSubcategory(subcategory);
//   };

//   const getChartOptions = () => {
//     const data = Object.entries(
//       manualData[selectedCategory]?.[selectedSubcategory] || {}
//     ).map(([network, price]) => ({
//       name: network,
//       value: typeof price === "number" ? price : null,
//     }));

//     return {
//       chart: { type: "packedbubble", height: "60%" },
//       title: {
//         text: "Categories Comparison: % of Medicare",
//         align: "center",
//         style: {
//           fontSize: "20px",
//           fontWeight: "bold",
//           fontFamily: "'Montserrat', serif",
//         },
//       },
//       tooltip: {
//         useHTML: true,
//         pointFormat: "<b>{point.name}</b>: ${point.value || 'Unavailable'}",
//       },
//       legend: {
//         enabled: true,
//         layout: "horizontal",
//         align: "center",
//         verticalAlign: "bottom",
//         labelFormatter: function () {
//           return this.name; // Ensures legend displays network names
//         },
//       },
//       plotOptions: {
//         packedbubble: {
//           minSize: "30%",
//           maxSize: "100%",
//           layoutAlgorithm: { splitSeries: false, gravitationalConstant: 0.02 },
//           dataLabels: {
//             enabled: false,
//           },
//         },
//       },
//       series: data.map((item) => ({
//         name: item.name,
//         data: [{ name: item.name, value: item.value }],
//         colorByPoint: true,
//         // showInLegend: true,
//       })),
//       colors: ["#C1E7E7", "#4F7A8A", "#D1E8FF", "#FFD2A0"],
//     };
//   };

//   return (
//     <div className="container">
//       <nav className="breadcrumbs">
//         <ul className="breadcrumbs-list">
//           {breadcrumbs.map((crumb, index) => (
//             <li key={index} className="breadcrumb-item">
//               <button
//                 className={`breadcrumb-button ${
//                   level === crumb.level ? "active" : "hover"
//                 }`}
//                 onClick={crumb.action}
//               >
//                 {crumb.label}
//               </button>
//               {index < breadcrumbs.length - 1 && (
//                 <span className="breadcrumb-separator">/</span>
//               )}
//             </li>
//           ))}
//         </ul>
//       </nav>
//       <div className="content-card">
//         {level === 0 && (
//           <div>
//             <h2 className="title">Select a Category</h2>
//             <ul className="category-list">
//               {Object.keys(manualData).map((category, index) => (
//                 <li key={index}>
//                   <button
//                     className="category-button"
//                     onClick={() => goToCategory(category)}
//                   >
//                     {category}
//                   </button>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         )}
//         {level === 1 && selectedCategory && (
//           <div>
//             <h2 className="title">{selectedCategory}</h2>
//             <ul className="subcategory-list">
//               {Object.keys(manualData[selectedCategory]).map(
//                 (subcategory, index) => (
//                   <li key={index}>
//                     <button
//                       className="subcategory-button"
//                       onClick={() => goToSubcategory(subcategory)}
//                     >
//                       {subcategory}
//                     </button>
//                   </li>
//                 )
//               )}
//             </ul>
//           </div>
//         )}
//         {level === 2 && selectedSubcategory && selectedCategory && (
//           <div>
//             <h2 className="title">{selectedSubcategory}</h2>
//             <div className="chart-container">
//               <HighchartsReact
//                 highcharts={Highcharts}
//                 options={getChartOptions()}
//               />
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default DrillDownComponent;

// import React, { useState } from "react";
// import Highcharts from "highcharts/highstock";
// import HighchartsReact from "highcharts-react-official";
// import highchartsMore from "highcharts/highcharts-more";
// import "./DrillDownComponent.css";

// highchartsMore(Highcharts);
// const manualData = {
//   "Category III Codes": {
//     "Prostate Ablation Procedure": {
//       "Anthem Participating Network": 272.95,
//       "BC ID Blue Value POS Network": 333.09,
//       "BC ID Preferred Blue Network": 333.09,
//       "BC ID Preferred Blue PPO Network": 294.65,
//     },
//     "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
//       "Anthem Participating Network": 147.22,
//       "BC ID Blue Value POS Network": 147.22,
//       "BC ID Preferred Blue Network": 147.22,
//       "BC ID Preferred Blue PPO Network": 147.22,
//     },
//     "Laser Ablation Procedures": {
//       "Anthem Participating Network": 605.01,
//       "BC ID Blue Value POS Network": 605.01,
//       "BC ID Preferred Blue Network": 605.01,
//       "BC ID Preferred Blue PPO Network": 605.01,
//     },
//     "Stereotactic Intracranial Lesion Ablation Procedure": {
//       "Anthem Participating Network": 338.44,
//       "BC ID Blue Value POS Network": 298.36,
//       "BC ID Preferred Blue Network": 298.36,
//       "BC ID Preferred Blue PPO Network": 338.44,
//     },
//     "Transnasal EGD and Capsule Endoscopy Procedures": {
//       "Anthem Participating Network": 584.68,
//       "BC ID Blue Value POS Network": 584.68,
//       "BC ID Preferred Blue Network": 584.68,
//       "BC ID Preferred Blue PPO Network": 584.68,
//     },
//     "Carotid Sinus Baroreflex Activation Device Procedures": {
//       "Anthem Participating Network": 278.66,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 278.66,
//     },
//     "Imaging, Testing, Implantation and Other Services": {
//       "Anthem Participating Network": 619.55,
//       "BC ID Blue Value POS Network": 619.55,
//       "BC ID Preferred Blue Network": 619.55,
//       "BC ID Preferred Blue PPO Network": 619.55,
//     },
//     "Insertion of Aqueous Drainage Device": {
//       "Anthem Participating Network": 207.97,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 207.97,
//     },
//     "Intracardiac Ischemia Monitoring Procedures": {
//       "Anthem Participating Network": 153.86,
//       "BC ID Blue Value POS Network": 153.86,
//       "BC ID Preferred Blue Network": 153.86,
//       "BC ID Preferred Blue PPO Network": 153.86,
//     },
//     "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
//       "Anthem Participating Network": 178.15,
//       "BC ID Blue Value POS Network": 178.15,
//       "BC ID Preferred Blue Network": 178.15,
//       "BC ID Preferred Blue PPO Network": 178.15,
//     },
//   },
//   "Chemotherapy Drugs": {
//     "Chemotherapy Drugs": {
//       "Anthem Participating Network": 250.98,
//       "BC ID Blue Value POS Network": 243.03,
//       "BC ID Preferred Blue Network": 243.03,
//       "BC ID Preferred Blue PPO Network": 242.29,
//     },
//   },
//   "Drugs Administered Other than Oral Method": {
//     "Drugs, Administered by Injection": {
//       "Anthem Participating Network": 260.7,
//       "BC ID Blue Value POS Network": 247.36,
//       "BC ID Preferred Blue Network": 247.36,
//       "BC ID Preferred Blue PPO Network": 252.38,
//     },
//     "Miscellaneous Drugs": {
//       "Anthem Participating Network": 234.78,
//       "BC ID Blue Value POS Network": 239.27,
//       "BC ID Preferred Blue Network": 239.27,
//       "BC ID Preferred Blue PPO Network": 235.47,
//     },
//     "Clotting Factors": {
//       "Anthem Participating Network": 227.49,
//       "BC ID Blue Value POS Network": 215.47,
//       "BC ID Preferred Blue Network": 215.47,
//       "BC ID Preferred Blue PPO Network": 214.66,
//     },
//     "Chemotherapy Drugs, Oral Administration": {
//       "Anthem Participating Network": 241.13,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 241.13,
//     },
//     "Immunosuppressive Drugs": {
//       "Anthem Participating Network": 188.53,
//       "BC ID Blue Value POS Network": 188.53,
//       "BC ID Preferred Blue Network": 188.53,
//       "BC ID Preferred Blue PPO Network": 188.53,
//     },
//   },
//   "Evaluation and Management": {
//     "Preventive Medicine Services": {
//       "Anthem Participating Network": 298.53,
//       "BC ID Blue Value POS Network": 288.5,
//       "BC ID Preferred Blue Network": 288.5,
//       "BC ID Preferred Blue PPO Network": 312.29,
//     },
//     "Transitional Care Management Services": {
//       "Anthem Participating Network": 309.17,
//       "BC ID Blue Value POS Network": 314.26,
//       "BC ID Preferred Blue Network": 314.26,
//       "BC ID Preferred Blue PPO Network": 322.86,
//     },
//     "Psychiatric Collaborative Care Management Services": {
//       "Anthem Participating Network": 293.26,
//       "BC ID Blue Value POS Network": 213.38,
//       "BC ID Preferred Blue Network": 213.38,
//       "BC ID Preferred Blue PPO Network": 293.26,
//     },
//     "Care Management Services": {
//       "Anthem Participating Network": 204.65,
//       "BC ID Blue Value POS Network": 204.65,
//       "BC ID Preferred Blue Network": 204.65,
//       "BC ID Preferred Blue PPO Network": 204.65,
//     },
//     "Newborn Care Services": {
//       "Anthem Participating Network": 389.88,
//       "BC ID Blue Value POS Network": 389.88,
//       "BC ID Preferred Blue Network": 389.88,
//       "BC ID Preferred Blue PPO Network": 389.88,
//     },
//     "Delivery/Birthing Room Attendance and Resuscitation Services": {
//       "Anthem Participating Network": 209.07,
//       "BC ID Blue Value POS Network": 209.07,
//       "BC ID Preferred Blue Network": 209.07,
//       "BC ID Preferred Blue PPO Network": 209.07,
//     },
//   },
//   "Medicine Services and Procedures": {
//     "Cardiovascular Procedures": {
//       "Anthem Participating Network": 360.68,
//       "BC ID Blue Value POS Network": 339.42,
//       "BC ID Preferred Blue Network": 339.42,
//       "BC ID Preferred Blue PPO Network": 359.71,
//     },
//   },
// };

// const DrillDownComponent = () => {
//   const [level, setLevel] = useState(0);
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [selectedSubcategory, setSelectedSubcategory] = useState(null);

//   const breadcrumbs = [
//     { label: "Category", level: 0, action: () => resetNavigation() },
//     ...(selectedCategory
//       ? [
//           {
//             label: ` ${selectedCategory}`,
//             level: 1,
//             action: () => goToCategory(selectedCategory),
//           },
//         ]
//       : []),
//     ...(selectedSubcategory
//       ? [
//           {
//             label: `${selectedSubcategory}`,
//             level: 2,
//             action: () => goToSubcategory(selectedSubcategory),
//           },
//         ]
//       : []),
//   ];

//   const resetNavigation = () => {
//     setLevel(0);
//     setSelectedCategory(null);
//     setSelectedSubcategory(null);
//   };

//   const goToCategory = (category) => {
//     setLevel(1);
//     setSelectedCategory(category);
//     setSelectedSubcategory(null);
//   };

//   const goToSubcategory = (subcategory) => {
//     setLevel(2);
//     setSelectedSubcategory(subcategory);
//   };

//   // Generate random colors for each network
//   const generateColor = (index) => {
//     const colors = [
//       "#C1E7E7",
//       "#4F7A8A",
//       "#D1E8FF",
//       "#FFD2A0",
//       "#FFB6C1",
//       "#A1C6EA",
//       "#FFEB8D",
//       "#FFD700",
//       "#8B0000",
//       "#2E8B57",
//       "#6A5ACD",
//       "#20B2AA",
//     ];
//     return colors[index % colors.length]; // Cycle through predefined colors
//   };

//   const getChartOptions = () => {
//     const data = Object.entries(
//       manualData[selectedCategory]?.[selectedSubcategory] || {}
//     ).map(([network, price], index) => ({
//       name: network,
//       value: typeof price === "number" ? price : null,
//       color: generateColor(index), // Apply a dynamic color for each network
//     }));

//     return {
//       chart: { type: "packedbubble", height: "40%" },
//       title: {
//         text: "Categories Comparison: % of Medicare",
//         align: "center",
//         style: {
//           fontSize: "20px",
//           fontWeight: "bold",
//           fontFamily: "'Montserrat', serif",
//         },
//       },

//       legend: {
//         enabled: true,
//         layout: "horizontal",
//         align: "center",
//         verticalAlign: "bottom",
//       },
//       plotOptions: {
//         packedbubble: {
//           minSize: "30%",
//           maxSize: "100%",
//           layoutAlgorithm: { splitSeries: false, gravitationalConstant: 0.02 },
//           dataLabels: {
//             enabled: true,
//             format: "{point.value}", // Show value inside bubble
//             style: {
//               color: "#000",
//               textOutline: "none",
//               fontSize: "11px",
//               fontWeight: "bold",
//             },
//           },
//         },
//       },
//       credits: {
//         enabled: false,
//       },
//       series: data.map((item) => ({
//         name: item.name, // Network name
//         data: [{ name: item.name, value: item.value }],
//         color: item.color, // Apply dynamic color
//         showInLegend: true, // Ensure it appears in the legend
//       })),
//     };
//   };

//   return (
//     <div className="container1">
//       <nav className="breadcrumbs">
//         <ul className="breadcrumbs-list">
//           {breadcrumbs.map((crumb, index) => (
//             <li key={index} className="breadcrumb-item">
//               <button
//                 className={`breadcrumb-button ${
//                   level === crumb.level ? "active" : "hover"
//                 }`}
//                 onClick={crumb.action}
//               >
//                 {crumb.label}
//               </button>
//               {index < breadcrumbs.length - 1 && (
//                 <span className="breadcrumb-separator">/</span>
//               )}
//             </li>
//           ))}
//         </ul>
//       </nav>
//       <div className="content-card">
//         {level === 0 && (
//           <div>
//             <h2 className="title">Select a Category</h2>
//             <ul className="category-list">
//               {Object.keys(manualData).map((category, index) => (
//                 <li key={index}>
//                   <button
//                     className="category-button"
//                     onClick={() => goToCategory(category)}
//                   >
//                     {category}
//                   </button>
//                 </li>
//               ))}
//             </ul>
//           </div>
//         )}
//         {level === 1 && selectedCategory && (
//           <div>
//             <h2 className="title">{selectedCategory}</h2>
//             <ul className="subcategory-list">
//               {Object.keys(manualData[selectedCategory]).map(
//                 (subcategory, index) => (
//                   <li key={index}>
//                     <button
//                       className="subcategory-button"
//                       onClick={() => goToSubcategory(subcategory)}
//                     >
//                       {subcategory}
//                     </button>
//                   </li>
//                 )
//               )}
//             </ul>
//           </div>
//         )}
//         {level === 2 && selectedSubcategory && selectedCategory && (
//           <div>
//             {/* <h2 className="title">{selectedSubcategory}</h2> */}
//             <div className="chart-container">
//               <HighchartsReact
//                 highcharts={Highcharts}
//                 options={getChartOptions()}
//               />
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default DrillDownComponent;

// import React, { useState, useEffect } from "react";
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import drilldown from "highcharts/modules/drilldown";

// drilldown(Highcharts);

// const manualData = {
//   "Category III Codes": {
//     "Prostate Ablation Procedure": {
//       "Anthem Participating Network": 272.95,
//       "BC ID Blue Value POS Network": 333.09,
//       "BC ID Preferred Blue Network": 333.09,
//       "BC ID Preferred Blue PPO Network": 294.65,
//     },
//     "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
//       "Anthem Participating Network": 147.22,
//       "BC ID Blue Value POS Network": 147.22,
//       "BC ID Preferred Blue Network": 147.22,
//       "BC ID Preferred Blue PPO Network": 147.22,
//     },
//     "Laser Ablation Procedures": {
//       "Anthem Participating Network": 605.01,
//       "BC ID Blue Value POS Network": 605.01,
//       "BC ID Preferred Blue Network": 605.01,
//       "BC ID Preferred Blue PPO Network": 605.01,
//     },
//     "Stereotactic Intracranial Lesion Ablation Procedure": {
//       "Anthem Participating Network": 338.44,
//       "BC ID Blue Value POS Network": 298.36,
//       "BC ID Preferred Blue Network": 298.36,
//       "BC ID Preferred Blue PPO Network": 338.44,
//     },
//     "Transnasal EGD and Capsule Endoscopy Procedures": {
//       "Anthem Participating Network": 584.68,
//       "BC ID Blue Value POS Network": 584.68,
//       "BC ID Preferred Blue Network": 584.68,
//       "BC ID Preferred Blue PPO Network": 584.68,
//     },
//     "Carotid Sinus Baroreflex Activation Device Procedures": {
//       "Anthem Participating Network": 278.66,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 278.66,
//     },
//     "Imaging, Testing, Implantation and Other Services": {
//       "Anthem Participating Network": 619.55,
//       "BC ID Blue Value POS Network": 619.55,
//       "BC ID Preferred Blue Network": 619.55,
//       "BC ID Preferred Blue PPO Network": 619.55,
//     },
//     "Insertion of Aqueous Drainage Device": {
//       "Anthem Participating Network": 207.97,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 207.97,
//     },
//     "Intracardiac Ischemia Monitoring Procedures": {
//       "Anthem Participating Network": 153.86,
//       "BC ID Blue Value POS Network": 153.86,
//       "BC ID Preferred Blue Network": 153.86,
//       "BC ID Preferred Blue PPO Network": 153.86,
//     },
//     "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
//       "Anthem Participating Network": 178.15,
//       "BC ID Blue Value POS Network": 178.15,
//       "BC ID Preferred Blue Network": 178.15,
//       "BC ID Preferred Blue PPO Network": 178.15,
//     },
//   },
//   "Chemotherapy Drugs": {
//     "Chemotherapy Drugs": {
//       "Anthem Participating Network": 250.98,
//       "BC ID Blue Value POS Network": 243.03,
//       "BC ID Preferred Blue Network": 243.03,
//       "BC ID Preferred Blue PPO Network": 242.29,
//     },
//   },
//   "Drugs Administered Other than Oral Method": {
//     "Drugs, Administered by Injection": {
//       "Anthem Participating Network": 260.7,
//       "BC ID Blue Value POS Network": 247.36,
//       "BC ID Preferred Blue Network": 247.36,
//       "BC ID Preferred Blue PPO Network": 252.38,
//     },
//     "Miscellaneous Drugs": {
//       "Anthem Participating Network": 234.78,
//       "BC ID Blue Value POS Network": 239.27,
//       "BC ID Preferred Blue Network": 239.27,
//       "BC ID Preferred Blue PPO Network": 235.47,
//     },
//     "Clotting Factors": {
//       "Anthem Participating Network": 227.49,
//       "BC ID Blue Value POS Network": 215.47,
//       "BC ID Preferred Blue Network": 215.47,
//       "BC ID Preferred Blue PPO Network": 214.66,
//     },
//     "Chemotherapy Drugs, Oral Administration": {
//       "Anthem Participating Network": 241.13,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 241.13,
//     },
//     "Immunosuppressive Drugs": {
//       "Anthem Participating Network": 188.53,
//       "BC ID Blue Value POS Network": 188.53,
//       "BC ID Preferred Blue Network": 188.53,
//       "BC ID Preferred Blue PPO Network": 188.53,
//     },
//   },
//   "Evaluation and Management": {
//     "Preventive Medicine Services": {
//       "Anthem Participating Network": 298.53,
//       "BC ID Blue Value POS Network": 288.5,
//       "BC ID Preferred Blue Network": 288.5,
//       "BC ID Preferred Blue PPO Network": 312.29,
//     },
//     "Transitional Care Management Services": {
//       "Anthem Participating Network": 309.17,
//       "BC ID Blue Value POS Network": 314.26,
//       "BC ID Preferred Blue Network": 314.26,
//       "BC ID Preferred Blue PPO Network": 322.86,
//     },
//     "Psychiatric Collaborative Care Management Services": {
//       "Anthem Participating Network": 293.26,
//       "BC ID Blue Value POS Network": 213.38,
//       "BC ID Preferred Blue Network": 213.38,
//       "BC ID Preferred Blue PPO Network": 293.26,
//     },
//     "Care Management Services": {
//       "Anthem Participating Network": 204.65,
//       "BC ID Blue Value POS Network": 204.65,
//       "BC ID Preferred Blue Network": 204.65,
//       "BC ID Preferred Blue PPO Network": 204.65,
//     },
//     "Newborn Care Services": {
//       "Anthem Participating Network": 389.88,
//       "BC ID Blue Value POS Network": 389.88,
//       "BC ID Preferred Blue Network": 389.88,
//       "BC ID Preferred Blue PPO Network": 389.88,
//     },
//     "Delivery/Birthing Room Attendance and Resuscitation Services": {
//       "Anthem Participating Network": 209.07,
//       "BC ID Blue Value POS Network": 209.07,
//       "BC ID Preferred Blue Network": 209.07,
//       "BC ID Preferred Blue PPO Network": 209.07,
//     },
//   },
//   "Medicine Services and Procedures": {
//     "Cardiovascular Procedures": {
//       "Anthem Participating Network": 360.68,
//       "BC ID Blue Value POS Network": 339.42,
//       "BC ID Preferred Blue Network": 339.42,
//       "BC ID Preferred Blue PPO Network": 359.71,
//     },
//   },
// };

// const transformData = (data) => {
//   const seriesData = [];
//   const drilldownSeries = [];

//   Object.keys(data).forEach((category) => {
//     const subcategories = data[category];
//     const categoryData = [];

//     Object.keys(subcategories).forEach((subcategory) => {
//       const networks = subcategories[subcategory];
//       const subcategoryData = [];
//       let homeNetwork = null;

//       Object.keys(networks).forEach((network, index) => {
//         if (networks[network] !== "Unavailable") {
//           if (index === 0) {
//             homeNetwork = networks[network];
//           }
//           subcategoryData.push([network, networks[network]]);
//         }
//       });

//       if (homeNetwork !== null) {
//         categoryData.push({
//           name: subcategory,
//           y: homeNetwork,
//           drilldown: subcategory,
//         });
//       }
//       drilldownSeries.push({
//         id: subcategory,
//         name: subcategory,
//         data: subcategoryData,
//       });
//     });

//     seriesData.push({
//       name: category,
//       y: categoryData.length,
//       drilldown: category,
//     });
//     drilldownSeries.push({ id: category, name: category, data: categoryData });
//   });

//   return { seriesData, drilldownSeries };
// };

// const DrilldownChart = () => {
//   const [options, setOptions] = useState({});
//   const [data, setData] = useState(manualData);

//   useEffect(() => {
//     const { seriesData, drilldownSeries } = transformData(data);

//     setOptions({
//       chart: {
//         type: "column",
//       },
//       title: {
//         text: "Network Comprasrion",
//         style: {
//           color: "#333333",
//           fontFamily: "'Montserrat', serif",
//           fontSize: "20px",
//           fontWeight: "bold",
//         },
//       },

//       xAxis: {
//         type: "category",
//         style: {
//           textDecoration: "none",
//           color: "#333333",
//         },
//       },
//       yAxis: {
//         title: {
//           text: "% of Medicare",
//           style: {
//             color: "#555555",
//             fontFamily: "'Roboto Flex', serif",
//             fontSize: "12px",
//           },
//         },
//       },
//       credits: {
//         enabled: false,
//       },
//       tooltip: {
//         headerFormat: "<span style='font-size:11px'>{point.key}</span><br/>",
//         pointFormat:
//           "<span style='color:{point.color}'>\u25CF</span> {series.name}: <b>{point.y}</b><br/>",
//       },
//       plotOptions: {
//         series: {
//           borderWidth: 0,
//           dataLabels: {
//             enabled: true,
//             format: "{point.y}",
//             style: {
//               color: "#333333",
//               fontFamily: "'Roboto Flex', serif",
//               fontSize: "12px",
//             },
//           },
//         },
//       },
//       legend: {
//         enabled: false,
//       },
//       plotOptions: {
//         series: {
//           borderWidth: 0,
//           dataLabels: {
//             enabled: true,
//           },
//         },
//       },
//       series: [
//         {
//           name: "Categories",
//           colorByPoint: true,
//           data: seriesData,
//         },
//       ],
//       drilldown: {
//         series: drilldownSeries,
//       },
//     });
//   }, [data]);

//   return <HighchartsReact highcharts={Highcharts} options={options} />;
// };

// export default DrilldownChart;

// import React, { useState, useEffect } from "react";
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import drilldown from "highcharts/modules/drilldown";

// drilldown(Highcharts);

// const manualData = {
//   "Category III Codes": {
//     "Prostate Ablation Procedure": {
//       "Anthem Participating Network": 272.95,
//       "BC ID Blue Value POS Network": 333.09,
//       "BC ID Preferred Blue Network": 333.09,
//       "BC ID Preferred Blue PPO Network": 294.65,
//     },
//     "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
//       "Anthem Participating Network": 147.22,
//       "BC ID Blue Value POS Network": 147.22,
//       "BC ID Preferred Blue Network": 147.22,
//       "BC ID Preferred Blue PPO Network": 147.22,
//     },
//     "Laser Ablation Procedures": {
//       "Anthem Participating Network": 605.01,
//       "BC ID Blue Value POS Network": 605.01,
//       "BC ID Preferred Blue Network": 605.01,
//       "BC ID Preferred Blue PPO Network": 605.01,
//     },
//     "Stereotactic Intracranial Lesion Ablation Procedure": {
//       "Anthem Participating Network": 338.44,
//       "BC ID Blue Value POS Network": 298.36,
//       "BC ID Preferred Blue Network": 298.36,
//       "BC ID Preferred Blue PPO Network": 338.44,
//     },
//     "Transnasal EGD and Capsule Endoscopy Procedures": {
//       "Anthem Participating Network": 584.68,
//       "BC ID Blue Value POS Network": 584.68,
//       "BC ID Preferred Blue Network": 584.68,
//       "BC ID Preferred Blue PPO Network": 584.68,
//     },
//     "Carotid Sinus Baroreflex Activation Device Procedures": {
//       "Anthem Participating Network": 278.66,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 278.66,
//     },
//     "Imaging, Testing, Implantation and Other Services": {
//       "Anthem Participating Network": 619.55,
//       "BC ID Blue Value POS Network": 619.55,
//       "BC ID Preferred Blue Network": 619.55,
//       "BC ID Preferred Blue PPO Network": 619.55,
//     },
//     "Insertion of Aqueous Drainage Device": {
//       "Anthem Participating Network": 207.97,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 207.97,
//     },
//     "Intracardiac Ischemia Monitoring Procedures": {
//       "Anthem Participating Network": 153.86,
//       "BC ID Blue Value POS Network": 153.86,
//       "BC ID Preferred Blue Network": 153.86,
//       "BC ID Preferred Blue PPO Network": 153.86,
//     },
//     "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
//       "Anthem Participating Network": 178.15,
//       "BC ID Blue Value POS Network": 178.15,
//       "BC ID Preferred Blue Network": 178.15,
//       "BC ID Preferred Blue PPO Network": 178.15,
//     },
//   },
//   "Chemotherapy Drugs": {
//     "Chemotherapy Drugs": {
//       "Anthem Participating Network": 250.98,
//       "BC ID Blue Value POS Network": 243.03,
//       "BC ID Preferred Blue Network": 243.03,
//       "BC ID Preferred Blue PPO Network": 242.29,
//     },
//   },
//   "Drugs Administered Other than Oral Method": {
//     "Drugs, Administered by Injection": {
//       "Anthem Participating Network": 260.7,
//       "BC ID Blue Value POS Network": 247.36,
//       "BC ID Preferred Blue Network": 247.36,
//       "BC ID Preferred Blue PPO Network": 252.38,
//     },
//     "Miscellaneous Drugs": {
//       "Anthem Participating Network": 234.78,
//       "BC ID Blue Value POS Network": 239.27,
//       "BC ID Preferred Blue Network": 239.27,
//       "BC ID Preferred Blue PPO Network": 235.47,
//     },
//     "Clotting Factors": {
//       "Anthem Participating Network": 227.49,
//       "BC ID Blue Value POS Network": 215.47,
//       "BC ID Preferred Blue Network": 215.47,
//       "BC ID Preferred Blue PPO Network": 214.66,
//     },
//     "Chemotherapy Drugs, Oral Administration": {
//       "Anthem Participating Network": 241.13,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 241.13,
//     },
//     "Immunosuppressive Drugs": {
//       "Anthem Participating Network": 188.53,
//       "BC ID Blue Value POS Network": 188.53,
//       "BC ID Preferred Blue Network": 188.53,
//       "BC ID Preferred Blue PPO Network": 188.53,
//     },
//   },
//   "Evaluation and Management": {
//     "Preventive Medicine Services": {
//       "Anthem Participating Network": 298.53,
//       "BC ID Blue Value POS Network": 288.5,
//       "BC ID Preferred Blue Network": 288.5,
//       "BC ID Preferred Blue PPO Network": 312.29,
//     },
//     "Transitional Care Management Services": {
//       "Anthem Participating Network": 309.17,
//       "BC ID Blue Value POS Network": 314.26,
//       "BC ID Preferred Blue Network": 314.26,
//       "BC ID Preferred Blue PPO Network": 322.86,
//     },
//     "Psychiatric Collaborative Care Management Services": {
//       "Anthem Participating Network": 293.26,
//       "BC ID Blue Value POS Network": 213.38,
//       "BC ID Preferred Blue Network": 213.38,
//       "BC ID Preferred Blue PPO Network": 293.26,
//     },
//     "Care Management Services": {
//       "Anthem Participating Network": 204.65,
//       "BC ID Blue Value POS Network": 204.65,
//       "BC ID Preferred Blue Network": 204.65,
//       "BC ID Preferred Blue PPO Network": 204.65,
//     },
//     "Newborn Care Services": {
//       "Anthem Participating Network": 389.88,
//       "BC ID Blue Value POS Network": 389.88,
//       "BC ID Preferred Blue Network": 389.88,
//       "BC ID Preferred Blue PPO Network": 389.88,
//     },
//     "Delivery/Birthing Room Attendance and Resuscitation Services": {
//       "Anthem Participating Network": 209.07,
//       "BC ID Blue Value POS Network": 209.07,
//       "BC ID Preferred Blue Network": 209.07,
//       "BC ID Preferred Blue PPO Network": 209.07,
//     },
//   },
//   "Medicine Services and Procedures": {
//     "Cardiovascular Procedures": {
//       "Anthem Participating Network": 360.68,
//       "BC ID Blue Value POS Network": 339.42,
//       "BC ID Preferred Blue Network": 339.42,
//       "BC ID Preferred Blue PPO Network": 359.71,
//     },
//   },
// };

// const colorPalette = ["#c0e7e7", "#507a8a", "#d1e8ff", "#ffd29f"];

// const transformData = (data) => {
//   const seriesData = [];
//   const drilldownSeries = [];
//   let colorIndex = 0;

//   Object.keys(data).forEach((category) => {
//     const subcategories = data[category];
//     const categoryData = [];
//     const categoryColor = colorPalette[colorIndex % colorPalette.length];
//     colorIndex++;

//     Object.keys(subcategories).forEach((subcategory) => {
//       const networks = subcategories[subcategory];
//       const subcategoryData = [];
//       let homeNetwork = null;

//       Object.keys(networks).forEach((network, index) => {
//         if (networks[network] !== "Unavailable") {
//           if (index === 0) {
//             homeNetwork = networks[network];
//           }
//           subcategoryData.push({
//             name: network,
//             y: networks[network],
//             color: colorPalette[(colorIndex + index) % colorPalette.length],
//           });
//         }
//       });

//       if (homeNetwork !== null) {
//         categoryData.push({
//           name: subcategory,
//           y: homeNetwork,
//           drilldown: subcategory,
//           color: categoryColor,
//         });
//       }
//       drilldownSeries.push({
//         id: subcategory,
//         name: subcategory,
//         data: subcategoryData,
//         color: categoryColor,
//       });
//     });

//     seriesData.push({
//       name: category,
//       y: categoryData.length,
//       drilldown: category,
//       color: categoryColor,
//     });
//     drilldownSeries.push({
//       id: category,
//       name: category,
//       data: categoryData,
//       color: categoryColor,
//     });
//   });

//   return { seriesData, drilldownSeries };
// };

// const DrilldownChart = () => {
//   const [options, setOptions] = useState({});
//   const [data, setData] = useState(manualData);

//   useEffect(() => {
//     const { seriesData, drilldownSeries } = transformData(data);

//     setOptions({
//       chart: {
//         type: "column",
//       },
//       title: {
//         text: "Drilldown Chart with Three Levels",
//       },
//       xAxis: {
//         type: "category",
//       },
//       legend: {
//         enabled: false,
//       },
//       plotOptions: {
//         series: {
//           borderWidth: 0,
//           dataLabels: {
//             enabled: true,
//           },
//         },
//       },
//       series: [
//         {
//           name: "Categories",
//           colorByPoint: false,
//           data: seriesData,
//         },
//       ],
//       drilldown: {
//         series: drilldownSeries,
//       },
//     });
//   }, [data]);

//   return <HighchartsReact highcharts={Highcharts} options={options} />;
// };

// export default DrilldownChart;

// import React, { useState, useEffect } from "react";
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import drilldown from "highcharts/modules/drilldown";

// drilldown(Highcharts);

// const manualData = {
//   "Category III Codes": {
//     "Prostate Ablation Procedure": {
//       "Anthem Participating Network": 272.95,
//       "BC ID Blue Value POS Network": 333.09,
//       "BC ID Preferred Blue Network": 333.09,
//       "BC ID Preferred Blue PPO Network": 294.65,
//     },
//     "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
//       "Anthem Participating Network": 147.22,
//       "BC ID Blue Value POS Network": 147.22,
//       "BC ID Preferred Blue Network": 147.22,
//       "BC ID Preferred Blue PPO Network": 147.22,
//     },
//     "Laser Ablation Procedures": {
//       "Anthem Participating Network": 605.01,
//       "BC ID Blue Value POS Network": 605.01,
//       "BC ID Preferred Blue Network": 605.01,
//       "BC ID Preferred Blue PPO Network": 605.01,
//     },
//     "Stereotactic Intracranial Lesion Ablation Procedure": {
//       "Anthem Participating Network": 338.44,
//       "BC ID Blue Value POS Network": 298.36,
//       "BC ID Preferred Blue Network": 298.36,
//       "BC ID Preferred Blue PPO Network": 338.44,
//     },
//     "Transnasal EGD and Capsule Endoscopy Procedures": {
//       "Anthem Participating Network": 584.68,
//       "BC ID Blue Value POS Network": 584.68,
//       "BC ID Preferred Blue Network": 584.68,
//       "BC ID Preferred Blue PPO Network": 584.68,
//     },
//     "Carotid Sinus Baroreflex Activation Device Procedures": {
//       "Anthem Participating Network": 278.66,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 278.66,
//     },
//     "Imaging, Testing, Implantation and Other Services": {
//       "Anthem Participating Network": 619.55,
//       "BC ID Blue Value POS Network": 619.55,
//       "BC ID Preferred Blue Network": 619.55,
//       "BC ID Preferred Blue PPO Network": 619.55,
//     },
//     "Insertion of Aqueous Drainage Device": {
//       "Anthem Participating Network": 207.97,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 207.97,
//     },
//     "Intracardiac Ischemia Monitoring Procedures": {
//       "Anthem Participating Network": 153.86,
//       "BC ID Blue Value POS Network": 153.86,
//       "BC ID Preferred Blue Network": 153.86,
//       "BC ID Preferred Blue PPO Network": 153.86,
//     },
//     "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
//       "Anthem Participating Network": 178.15,
//       "BC ID Blue Value POS Network": 178.15,
//       "BC ID Preferred Blue Network": 178.15,
//       "BC ID Preferred Blue PPO Network": 178.15,
//     },
//   },
//   "Chemotherapy Drugs": {
//     "Chemotherapy Drugs": {
//       "Anthem Participating Network": 250.98,
//       "BC ID Blue Value POS Network": 243.03,
//       "BC ID Preferred Blue Network": 243.03,
//       "BC ID Preferred Blue PPO Network": 242.29,
//     },
//   },
//   "Drugs Administered Other than Oral Method": {
//     "Drugs, Administered by Injection": {
//       "Anthem Participating Network": 260.7,
//       "BC ID Blue Value POS Network": 247.36,
//       "BC ID Preferred Blue Network": 247.36,
//       "BC ID Preferred Blue PPO Network": 252.38,
//     },
//     "Miscellaneous Drugs": {
//       "Anthem Participating Network": 234.78,
//       "BC ID Blue Value POS Network": 239.27,
//       "BC ID Preferred Blue Network": 239.27,
//       "BC ID Preferred Blue PPO Network": 235.47,
//     },
//     "Clotting Factors": {
//       "Anthem Participating Network": 227.49,
//       "BC ID Blue Value POS Network": 215.47,
//       "BC ID Preferred Blue Network": 215.47,
//       "BC ID Preferred Blue PPO Network": 214.66,
//     },
//     "Chemotherapy Drugs, Oral Administration": {
//       "Anthem Participating Network": 241.13,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 241.13,
//     },
//     "Immunosuppressive Drugs": {
//       "Anthem Participating Network": 188.53,
//       "BC ID Blue Value POS Network": 188.53,
//       "BC ID Preferred Blue Network": 188.53,
//       "BC ID Preferred Blue PPO Network": 188.53,
//     },
//   },
//   "Evaluation and Management": {
//     "Preventive Medicine Services": {
//       "Anthem Participating Network": 298.53,
//       "BC ID Blue Value POS Network": 288.5,
//       "BC ID Preferred Blue Network": 288.5,
//       "BC ID Preferred Blue PPO Network": 312.29,
//     },
//     "Transitional Care Management Services": {
//       "Anthem Participating Network": 309.17,
//       "BC ID Blue Value POS Network": 314.26,
//       "BC ID Preferred Blue Network": 314.26,
//       "BC ID Preferred Blue PPO Network": 322.86,
//     },
//     "Psychiatric Collaborative Care Management Services": {
//       "Anthem Participating Network": 293.26,
//       "BC ID Blue Value POS Network": 213.38,
//       "BC ID Preferred Blue Network": 213.38,
//       "BC ID Preferred Blue PPO Network": 293.26,
//     },
//     "Care Management Services": {
//       "Anthem Participating Network": 204.65,
//       "BC ID Blue Value POS Network": 204.65,
//       "BC ID Preferred Blue Network": 204.65,
//       "BC ID Preferred Blue PPO Network": 204.65,
//     },
//     "Newborn Care Services": {
//       "Anthem Participating Network": 389.88,
//       "BC ID Blue Value POS Network": 389.88,
//       "BC ID Preferred Blue Network": 389.88,
//       "BC ID Preferred Blue PPO Network": 389.88,
//     },
//     "Delivery/Birthing Room Attendance and Resuscitation Services": {
//       "Anthem Participating Network": 209.07,
//       "BC ID Blue Value POS Network": 209.07,
//       "BC ID Preferred Blue Network": 209.07,
//       "BC ID Preferred Blue PPO Network": 209.07,
//     },
//   },
//   "Medicine Services and Procedures": {
//     "Cardiovascular Procedures": {
//       "Anthem Participating Network": 360.68,
//       "BC ID Blue Value POS Network": 339.42,
//       "BC ID Preferred Blue Network": 339.42,
//       "BC ID Preferred Blue PPO Network": 359.71,
//     },
//   },
// };

// const colorPalette = ["#c0e7e7", "#507a8a", "#d1e8ff", "#ffd29f"];

// const transformData = (data) => {
//   const seriesData = [];
//   const drilldownSeries = [];
//   let colorIndex = 0;

//   Object.keys(data).forEach((category) => {
//     const subcategories = data[category];
//     const categoryData = [];
//     const categoryColor = colorPalette[colorIndex % colorPalette.length];
//     colorIndex++;

//     const sortedSubcategories = Object.keys(subcategories).sort();

//     sortedSubcategories.forEach((subcategory) => {
//       const uniqueSubcategoryId = `${subcategory}-${category}`;
//       const networks = subcategories[subcategory];
//       const subcategoryData = [];
//       let homeNetwork = null;

//       Object.keys(networks).forEach((network, index) => {
//         if (networks[network] !== "Unavailable") {
//           if (index === 0) {
//             homeNetwork = networks[network];
//           }
//           subcategoryData.push({
//             name: network,
//             y: networks[network],
//             color: colorPalette[(colorIndex + index) % colorPalette.length],
//           });
//         }
//       });

//       if (homeNetwork !== null) {
//         categoryData.push({
//           name: subcategory,
//           y: homeNetwork,
//           drilldown: uniqueSubcategoryId,
//           color: categoryColor,
//         });
//       }
//       drilldownSeries.push({
//         id: uniqueSubcategoryId,
//         name: subcategory,
//         data: subcategoryData,
//         color: categoryColor,
//       });
//     });

//     seriesData.push({
//       name: category,
//       y: categoryData.length,
//       drilldown: category,
//       color: categoryColor,
//     });
//     drilldownSeries.push({
//       id: category,
//       name: category,
//       data: categoryData,
//       color: categoryColor,
//     });
//   });

//   return { seriesData, drilldownSeries };
// };

// const DrilldownChart = () => {
//   const [data, setData] = useState(manualData);
//   const [options, setOptions] = useState({});

//   // useEffect(() => {
//   //   const { seriesData, drilldownSeries } = transformData(data);

//   //   setOptions({
//   //     chart: {
//   //       type: "column",
//   //       backgroundColor: "#FBFEFF",
//   //       borderRadius: 4,
//   //       fontFamily: "'Roboto Flex', serif",
//   //       height: 400, // Increased height
//   //     },
//   //     title: {
//   //       text: "Network Comparison by Procedure Category: OPPS",
//   //       style: {
//   //         color: "#333333",
//   //         fontFamily: "'Montserrat', serif",
//   //         fontSize: "20px",
//   //         fontWeight: "bold",
//   //       },
//   //     },
//   //     subtitle: {
//   //       text: " Drilldown Chart with Three Levels",
//   //       style: {
//   //         color: "#555555",
//   //         fontFamily: "'Roboto Flex', serif",
//   //         fontSize: "14px",
//   //         fontWeight: "light",
//   //       },
//   //     },
//   //     xAxis: {
//   //       type: "category",
//   //       lineColor: "#CDCDCD",
//   //       lineWidth: 1,
//   //       labels: {
//   //         style: {
//   //           fontFamily: "'Roboto Flex', serif",
//   //           color: "#555555",
//   //           fontSize: "12px",
//   //         },
//   //       },
//   //     },
//   //     legend: {
//   //       enabled: false,
//   //     },
//   //     yAxis: {
//   //       title: {
//   //         text: "% of Medicare",
//   //         style: {
//   //           fontSize: "12px",
//   //           fontWeight: "light",
//   //           fontFamily: "'Roboto Flex', serif",
//   //         },
//   //         gridLineColor: "#EDEDED", // Light color (was too faint)
//   //         lineColor: "#CDCDCD", // Ensure a visible axis line
//   //         lineWidth: 1, // Add a border line to y-axis
//   //         labels: {
//   //           style: {
//   //             fontFamily: "'Roboto Flex', serif",
//   //             color: "#555555",
//   //             fontSize: "12px",
//   //           },
//   //         },
//   //       },
//   //     },
//   //     tooltip: {
//   //       headerFormat:
//   //         // ' <span style="font-size: 14px; color: #5A5A5A;  max-width: 120px; white-space: normal; word-wrap: break-word;">{point.key}</span> <span>  Drill Down chart </span> <br>' +
//   //         "<div style='display:flex; flex-direction:row; align-items: top; justify-content: space-between;' ><div style='margin-right: 0px; width:180px; white-space: normal; word-wrap: break-word;'>{point.key}</div> <div style=' display: flex;  justify-content: center; !important; width: 100px; background: #f4f4f9; border: none; border-radius: 4px; height: 20px; '>Drilldown Chart</div> </div>" +
//   //         '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
//   //       pointFormat:
//   //         "<div style='display:flex; flex-direction:row; align-items: center; justify-content: space-between;' ><div style='margin-right: 0px; width:180px; white-space: normal; word-wrap: break-word;'> {series.name} </div> <div style=' display: flex;  justify-content: right; !important; width: 80px; '><b>{point.y}%</b></div> </div>",
//   //       shared: true,
//   //       backgroundColor: "rgba(255, 255, 255, 1)",
//   //       borderColor: "#A9A9A9",
//   //       borderRadius: 7,
//   //       animation: false,
//   //       hideDelay: 0,
//   //       style: {
//   //         color: "#333",
//   //         fontFamily: "'Roboto Flex', serif",
//   //         transition: "none",
//   //         fontSize: "12px",
//   //         padding: "8px",
//   //         shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
//   //         zIndex: 99999,
//   //       },
//   //       shadow: true,
//   //       useHTML: true,
//   //       outside: true,
//   //     },
//   //     plotOptions: {
//   //       series: {
//   //         states: {
//   //           hover: {
//   //             enabled: false,
//   //           },
//   //         },
//   //         borderWidth: 0,

//   //         column: {
//   //           stacking: "percent", // Percentage stacking
//   //           borderWidth: 0.3,
//   //           borderRadius: 8,
//   //         },

//   //         dataLabels: {
//   //           enabled: true,
//   //           format: "{point.y:.2f}",
//   //           style: {
//   //             color: "#555555",
//   //             cursor: "pointer",
//   //             border: "none",
//   //             fontWeight: 500,
//   //             fontSize: "12px",
//   //             fontFamily: "'Roboto Flex', serif",
//   //             textDecoration: "none",
//   //           },
//   //         },
//   //       },
//   //     },

//   //     credits: {
//   //       enabled: false,
//   //     },
//   //     series: [
//   //       {
//   //         name: "Categories",
//   //         colorByPoint: false,
//   //         data: seriesData,
//   //       },
//   //     ],
//   //     drilldown: {
//   //       series: drilldownSeries,
//   //       activeAxisLabelStyle: {
//   //         color: "#555555",
//   //         cursor: "pointer",
//   //         fontWeight: "normal",
//   //         fontSize: "11px",
//   //         fontFamily: "'Roboto Flex', serif",
//   //         textDecoration: "none",
//   //       },
//   //       activeDataLabelStyle: {
//   //         color: "#555555",
//   //         cursor: "pointer",
//   //         border: "none",
//   //         fontWeight: 500,
//   //         fontSize: "12px",
//   //         fontFamily: "'Roboto Flex', serif",
//   //         textDecoration: "none",
//   //       },
//   //       breadcrumbs: {
//   //         buttonSpacing: 5,
//   //         buttonTheme: {
//   //           style: {
//   //             color: "#555555",
//   //             fontFamily: "'Roboto Flex', serif",
//   //             fontSize: "12px",
//   //             textDecoration: "none",
//   //             position: {
//   //               align: "left",
//   //               verticalAlign: "top",
//   //             },
//   //           },
//   //         },
//   //       },
//   //     },
//   //   });
//   // }, [data]);

//   useEffect(() => {
//     const { seriesData, drilldownSeries } = transformData(data);

//     setOptions({
//       chart: {
//         type: "column",
//         backgroundColor: "#FBFEFF",
//         borderRadius: 4,
//         fontFamily: "'Roboto Flex', serif",
//         height: 400, // Increased height
//       },
//       title: {
//         text: "Network Comparison by Procedure Category: OPPS",
//         style: {
//           color: "#333333",
//           fontFamily: "'Montserrat', serif",
//           fontSize: "20px",
//           fontWeight: "bold",
//         },
//       },
//       subtitle: {
//         text: "Drill to Subcategory",
//         style: {
//           color: "#555555",
//           fontFamily: "'Roboto Flex', serif",
//           fontSize: "14px",
//           fontWeight: "light",
//         },
//       },
//       xAxis: {
//         type: "category",
//         lineColor: "#CDCDCD",
//         lineWidth: 1,
//         labels: {
//           style: {
//             fontFamily: "'Roboto Flex', serif",
//             color: "#555555",
//             fontSize: "12px",
//           },
//         },
//       },
//       legend: {
//         enabled: false,
//       },
//       yAxis: {
//         title: {
//           text: "% of Medicare",
//           style: {
//             fontSize: "12px",
//             fontWeight: "light",
//             fontFamily: "'Roboto Flex', serif",
//           },
//           gridLineColor: "#EDEDED", // Light color (was too faint)
//           lineColor: "#CDCDCD", // Ensure a visible axis line
//           lineWidth: 1, // Add a border line to y-axis
//           labels: {
//             style: {
//               fontFamily: "'Roboto Flex', serif",
//               color: "#555555",
//               fontSize: "12px",
//             },
//           },
//         },
//       },
//       tooltip: {
//         headerFormat:
//           // ' <span style="font-size: 14px; color: #5A5A5A;  max-width: 120px; white-space: normal; word-wrap: break-word;">{point.key}</span> <span>  Drill Down chart </span> <br>' +
//           "<div style='display:flex; flex-direction:row; align-items: top; justify-content: space-between;' ><div style='margin-right: 0px; width:180px; white-space: normal; word-wrap: break-word;'>{point.key}</div> <div style=' display: flex;  justify-content: center; !important; width: 100px; background: #f4f4f9; border: none; border-radius: 4px; height: 20px; '>Drilldown Chart</div> </div>" +
//           '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
//         pointFormat:
//           "<div style='display:flex; flex-direction:row; align-items: center; justify-content: space-between;' ><div style='margin-right: 0px; width:180px; white-space: normal; word-wrap: break-word;'> {series.name} </div> <div style=' display: flex;  justify-content: right; !important; width: 80px; '><b>{point.y}%</b></div> </div>",
//         shared: true,
//         backgroundColor: "rgba(255, 255, 255, 1)",
//         borderColor: "#A9A9A9",
//         borderRadius: 7,
//         animation: false,
//         hideDelay: 0,
//         style: {
//           color: "#333",
//           fontFamily: "'Roboto Flex', serif",
//           transition: "none",
//           fontSize: "12px",
//           padding: "8px",
//           shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
//           zIndex: 99999,
//         },
//         shadow: true,
//         useHTML: true,
//         outside: true,
//       },
//       plotOptions: {
//         series: {
//           states: {
//             hover: {
//               enabled: false,
//             },
//           },
//           borderWidth: 0,

//           column: {
//             stacking: "percent", // Percentage stacking
//             borderWidth: 0.3,
//             borderRadius: 8,
//           },

//           dataLabels: {
//             enabled: true,
//             format: "{point.y:.2f}",
//             style: {
//               color: "#555555",
//               cursor: "pointer",
//               border: "none",
//               fontWeight: 500,
//               fontSize: "12px",
//               fontFamily: "'Roboto Flex', serif",
//               textDecoration: "none",
//             },
//           },
//         },
//       },
//       events: {
//         drilldown: function (e) {
//           if (e.seriesOptions) {
//             const id = e.seriesOptions.id;

//             if (id.includes("-")) {
//               // Third level: hide subtitle, keep title as is
//               this.setTitle(null, { text: "" });
//             } else {
//               // Second level: set a new title for subcategories
//               this.setTitle(
//                 {
//                   text: `Procedures in Category: ${e.point.name}`,
//                   style: {
//                     color: "#333333",
//                     fontFamily: "'Montserrat', serif",
//                     fontSize: "20px",
//                     fontWeight: "bold",
//                   },
//                 },
//                 { text: "" }
//               ); // Clear subtitle
//             }
//           }
//         },
//         drillup: function (e) {
//           if (this.drilldownLevels.length === 1) {
//             // Returning to category level (first drilldown)
//             this.setTitle(
//               {
//                 text: "Network Comparison by Procedure Category: OPPS",
//                 style: {
//                   color: "#333333",
//                   fontFamily: "'Montserrat', serif",
//                   fontSize: "20px",
//                   fontWeight: "bold",
//                 },
//               },
//               {
//                 text: " Drilldown Chart with Three Levels",
//                 style: {
//                   color: "#555555",
//                   fontFamily: "'Roboto Flex', serif",
//                   fontSize: "14px",
//                   fontWeight: "light",
//                 },
//               }
//             );
//           } else if (this.drilldownLevels.length === 0) {
//             // Fully back to the top level
//             this.setTitle(
//               {
//                 text: "Network Comparison by Procedure Category: OPPS",
//                 style: {
//                   color: "#333333",
//                   fontFamily: "'Montserrat', serif",
//                   fontSize: "20px",
//                   fontWeight: "bold",
//                 },
//               },
//               {
//                 text: " Drilldown Chart with Three Levels",
//                 style: {
//                   color: "#555555",
//                   fontFamily: "'Roboto Flex', serif",
//                   fontSize: "14px",
//                   fontWeight: "light",
//                 },
//               }
//             );
//           }
//         },
//       },
//       credits: {
//         enabled: false,
//       },
//       series: [
//         {
//           name: "Categories",
//           colorByPoint: false,
//           data: seriesData,
//         },
//       ],
//       drilldown: {
//         series: drilldownSeries,
//         activeAxisLabelStyle: {
//           color: "#555555",
//           cursor: "pointer",
//           fontWeight: "normal",
//           fontSize: "11px",
//           fontFamily: "'Roboto Flex', serif",
//           textDecoration: "none",
//         },
//         activeDataLabelStyle: {
//           color: "#555555",
//           cursor: "pointer",
//           border: "none",
//           fontWeight: 500,
//           fontSize: "12px",
//           fontFamily: "'Roboto Flex', serif",
//           textDecoration: "none",
//         },
//         breadcrumbs: {
//           buttonSpacing: 5,
//           buttonTheme: {
//             style: {
//               color: "#555555",
//               fontFamily: "'Roboto Flex', serif",
//               fontSize: "12px",
//               textDecoration: "none",
//               position: {
//                 align: "left",
//                 verticalAlign: "top",
//               },
//             },
//           },
//         },
//       },
//     });

//     Highcharts.addEvent(Highcharts.Chart, "drilldown", function (e) {
//       if (
//         e.seriesOptions &&
//         e.seriesOptions.id &&
//         e.seriesOptions.id.includes("-")
//       ) {
//         this.setTitle(null, { text: "" }); // Remove subtitle on last level
//       }
//     });

//     Highcharts.addEvent(Highcharts.Chart, "drillup", function () {
//       if (this.drilldownLevels.length === 1) {
//         this.setTitle(null, {
//           text: "Drill to Subcategory",
//         });
//       }
//       if (this.drilldownLevels.length === 2) {
//         this.setTitle(null, {
//           text: "Drill to Networks",
//         });
//       }
//     });
//   }, [data]);

//   return <HighchartsReact highcharts={Highcharts} options={options} />;
// };

// export default DrilldownChart;

import React, { useState, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import drilldown from "highcharts/modules/drilldown";

drilldown(Highcharts);

const manualData = {
  "Category III Codes": {
    "Prostate Ablation Procedure": {
      "Anthem Participating Network": 272.95,
      "BC ID Blue Value POS Network": 333.09,
      "BC ID Preferred Blue Network": 333.09,
      "BC ID Preferred Blue PPO Network": 294.65,
    },
    "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
      "Anthem Participating Network": 147.22,
      "BC ID Blue Value POS Network": 147.22,
      "BC ID Preferred Blue Network": 147.22,
      "BC ID Preferred Blue PPO Network": 147.22,
    },
    "Laser Ablation Procedures": {
      "Anthem Participating Network": 605.01,
      "BC ID Blue Value POS Network": 605.01,
      "BC ID Preferred Blue Network": 605.01,
      "BC ID Preferred Blue PPO Network": 605.01,
    },
    "Stereotactic Intracranial Lesion Ablation Procedure": {
      "Anthem Participating Network": 338.44,
      "BC ID Blue Value POS Network": 298.36,
      "BC ID Preferred Blue Network": 298.36,
      "BC ID Preferred Blue PPO Network": 338.44,
    },
    "Transnasal EGD and Capsule Endoscopy Procedures": {
      "Anthem Participating Network": 584.68,
      "BC ID Blue Value POS Network": 584.68,
      "BC ID Preferred Blue Network": 584.68,
      "BC ID Preferred Blue PPO Network": 584.68,
    },
    "Carotid Sinus Baroreflex Activation Device Procedures": {
      "Anthem Participating Network": 278.66,
      "BC ID Blue Value POS Network": "Unavailable",
      "BC ID Preferred Blue Network": "Unavailable",
      "BC ID Preferred Blue PPO Network": 278.66,
    },
    "Imaging, Testing, Implantation and Other Services": {
      "Anthem Participating Network": 619.55,
      "BC ID Blue Value POS Network": 619.55,
      "BC ID Preferred Blue Network": 619.55,
      "BC ID Preferred Blue PPO Network": 619.55,
    },
    "Insertion of Aqueous Drainage Device": {
      "Anthem Participating Network": 207.97,
      "BC ID Blue Value POS Network": "Unavailable",
      "BC ID Preferred Blue Network": "Unavailable",
      "BC ID Preferred Blue PPO Network": 207.97,
    },
    "Intracardiac Ischemia Monitoring Procedures": {
      "Anthem Participating Network": 153.86,
      "BC ID Blue Value POS Network": 153.86,
      "BC ID Preferred Blue Network": 153.86,
      "BC ID Preferred Blue PPO Network": 153.86,
    },
    "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
      "Anthem Participating Network": 178.15,
      "BC ID Blue Value POS Network": 178.15,
      "BC ID Preferred Blue Network": 178.15,
      "BC ID Preferred Blue PPO Network": 178.15,
    },
  },
  "Chemotherapy Drugs": {
    "Chemotherapy Drugs": {
      "Anthem Participating Network": 250.98,
      "BC ID Blue Value POS Network": 243.03,
      "BC ID Preferred Blue Network": 243.03,
      "BC ID Preferred Blue PPO Network": 242.29,
    },
  },
  "Drugs Administered Other than Oral Method": {
    "Drugs, Administered by Injection": {
      "Anthem Participating Network": 260.7,
      "BC ID Blue Value POS Network": 247.36,
      "BC ID Preferred Blue Network": 247.36,
      "BC ID Preferred Blue PPO Network": 252.38,
    },
    "Miscellaneous Drugs": {
      "Anthem Participating Network": 234.78,
      "BC ID Blue Value POS Network": 239.27,
      "BC ID Preferred Blue Network": 239.27,
      "BC ID Preferred Blue PPO Network": 235.47,
    },
    "Clotting Factors": {
      "Anthem Participating Network": 227.49,
      "BC ID Blue Value POS Network": 215.47,
      "BC ID Preferred Blue Network": 215.47,
      "BC ID Preferred Blue PPO Network": 214.66,
    },
    "Chemotherapy Drugs, Oral Administration": {
      "Anthem Participating Network": 241.13,
      "BC ID Blue Value POS Network": "Unavailable",
      "BC ID Preferred Blue Network": "Unavailable",
      "BC ID Preferred Blue PPO Network": 241.13,
    },
    "Immunosuppressive Drugs": {
      "Anthem Participating Network": 188.53,
      "BC ID Blue Value POS Network": 188.53,
      "BC ID Preferred Blue Network": 188.53,
      "BC ID Preferred Blue PPO Network": 188.53,
    },
  },
  "Evaluation and Management": {
    "Preventive Medicine Services": {
      "Anthem Participating Network": 298.53,
      "BC ID Blue Value POS Network": 288.5,
      "BC ID Preferred Blue Network": 288.5,
      "BC ID Preferred Blue PPO Network": 312.29,
    },
    "Transitional Care Management Services": {
      "Anthem Participating Network": 309.17,
      "BC ID Blue Value POS Network": 314.26,
      "BC ID Preferred Blue Network": 314.26,
      "BC ID Preferred Blue PPO Network": 322.86,
    },
    "Psychiatric Collaborative Care Management Services": {
      "Anthem Participating Network": 293.26,
      "BC ID Blue Value POS Network": 213.38,
      "BC ID Preferred Blue Network": 213.38,
      "BC ID Preferred Blue PPO Network": 293.26,
    },
    "Care Management Services": {
      "Anthem Participating Network": 204.65,
      "BC ID Blue Value POS Network": 204.65,
      "BC ID Preferred Blue Network": 204.65,
      "BC ID Preferred Blue PPO Network": 204.65,
    },
    "Newborn Care Services": {
      "Anthem Participating Network": 389.88,
      "BC ID Blue Value POS Network": 389.88,
      "BC ID Preferred Blue Network": 389.88,
      "BC ID Preferred Blue PPO Network": 389.88,
    },
    "Delivery/Birthing Room Attendance and Resuscitation Services": {
      "Anthem Participating Network": 209.07,
      "BC ID Blue Value POS Network": 209.07,
      "BC ID Preferred Blue Network": 209.07,
      "BC ID Preferred Blue PPO Network": 209.07,
    },
  },
  "Medicine Services and Procedures": {
    "Cardiovascular Procedures": {
      "Anthem Participating Network": 360.68,
      "BC ID Blue Value POS Network": 339.42,
      "BC ID Preferred Blue Network": 339.42,
      "BC ID Preferred Blue PPO Network": 359.71,
    },
  },
};

const colorPalette = ["#c0e7e7", "#507a8a", "#d1e8ff", "#ffd29f"];

const transformData = (data) => {
  const seriesData = [];
  const drilldownSeries = [];
  let colorIndex = 0;

  Object.keys(data).forEach((category) => {
    const subcategories = data[category];
    const categoryData = [];
    const categoryColor = colorPalette[colorIndex % colorPalette.length];
    colorIndex++;

    const sortedSubcategories = Object.keys(subcategories).sort();

    sortedSubcategories.forEach((subcategory) => {
      const uniqueSubcategoryId = `${subcategory}-${category}`;
      const networks = subcategories[subcategory];
      const subcategoryData = [];
      let homeNetwork = null;

      Object.keys(networks).forEach((network, index) => {
        if (networks[network] !== "Unavailable") {
          if (index === 0) {
            homeNetwork = networks[network];
          }
          subcategoryData.push({
            name: network,
            y: networks[network],
            color: colorPalette[(colorIndex + index) % colorPalette.length],
          });
        }
      });

      if (homeNetwork !== null) {
        categoryData.push({
          name: subcategory,
          y: homeNetwork,
          drilldown: uniqueSubcategoryId,
          color: categoryColor,
        });
      }
      drilldownSeries.push({
        id: uniqueSubcategoryId,
        name: subcategory,
        data: subcategoryData,
        color: categoryColor,
      });
    });

    seriesData.push({
      name: category,
      y: categoryData.length,
      drilldown: category,
      color: categoryColor,
    });
    drilldownSeries.push({
      id: category,
      name: category,
      data: categoryData,
      color: categoryColor,
    });
  });

  return { seriesData, drilldownSeries };
};

const DrilldownChart = () => {
  const [data, setData] = useState(manualData);
  const [options, setOptions] = useState({});

  useEffect(() => {
    const { seriesData, drilldownSeries } = transformData(data);

    setOptions({
      chart: {
        type: "column",
        backgroundColor: "#FBFEFF",
        borderRadius: 4,
        fontFamily: "'Roboto Flex', serif",
        height: 400,
        events: {
          drilldown: function (e) {
            if (e.seriesOptions) {
              const id = e.seriesOptions.id;
              if (id.includes("-")) {
                this.setTitle(
                  {
                    text: `Network Distribution in: ${e.point.name}`,
                    style: {
                      color: "#333333",
                      fontFamily: "'Montserrat', serif",
                      fontSize: "20px",
                      fontWeight: "bold",
                    },
                  },
                  { text: "" }
                );
              } else {
                this.setTitle(
                  {
                    text: `Procedures in Category: ${e.point.name}`,
                    style: {
                      color: "#333333",
                      fontFamily: "'Montserrat', serif",
                      fontSize: "20px",
                      fontWeight: "bold",
                    },
                  },
                  { text: "" }
                );
              }
            }
          },
          drillup: function (e) {
            if (
              this.drilldownLevels.length === 1 ||
              this.drilldownLevels.length === 0
            ) {
              this.setTitle(
                {
                  text: "Network Comparison by Procedure Category: OPPS",
                  style: {
                    color: "#333333",
                    fontFamily: "'Montserrat', serif",
                    fontSize: "20px",
                    fontWeight: "bold",
                  },
                },
                {
                  text: " Drilldown Chart with Three Levels",
                  style: {
                    color: "#555555",
                    fontFamily: "'Roboto Flex', serif",
                    fontSize: "14px",
                    fontWeight: "light",
                  },
                }
              );
            }
          },
        },
      },
      title: {
        text: "Network Comparison by Procedure Category: OPPS",
        style: {
          color: "#333333",
          fontFamily: "'Montserrat', serif",
          fontSize: "20px",
          fontWeight: "bold",
        },
      },
      subtitle: {
        text: " Drilldown Chart with Three Levels",
        style: {
          color: "#555555",
          fontFamily: "'Roboto Flex', serif",
          fontSize: "14px",
          fontWeight: "light",
        },
      },
      xAxis: {
        type: "category",
        lineColor: "#CDCDCD",
        lineWidth: 1,
        labels: {
          style: {
            fontFamily: "'Roboto Flex', serif",
            color: "#555555",
            fontSize: "12px",
          },
        },
      },
      legend: {
        enabled: false,
      },
      yAxis: {
        title: {
          text: "% of Medicare",
          style: {
            fontSize: "12px",
            fontWeight: "light",
            fontFamily: "'Roboto Flex', serif",
          },
          gridLineColor: "#EDEDED",
          lineColor: "#CDCDCD",
          lineWidth: 1,
          labels: {
            style: {
              fontFamily: "'Roboto Flex', serif",
              color: "#555555",
              fontSize: "12px",
            },
          },
        },
      },
      tooltip: {
        headerFormat:
          "<div style='display:flex; flex-direction:row; align-items: top; justify-content: space-between;' ><div style='margin-right: 0px; width:180px; white-space: normal; word-wrap: break-word;'>{point.key}</div> </div>" +
          '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
        pointFormat:
          "<div style='display:flex; flex-direction:row; align-items: center; justify-content: space-between;' ><div style='margin-right: 0px; width:180px; white-space: normal; word-wrap: break-word;'> {series.name} </div> <div style=' display: flex;  justify-content: right; !important; width: 80px; '><b>{point.y}%</b></div> </div>",
        shared: true,
        backgroundColor: "rgba(255, 255, 255, 1)",
        borderColor: "#A9A9A9",
        borderRadius: 7,
        animation: false,
        hideDelay: 0,
        style: {
          color: "#333",
          fontFamily: "'Roboto Flex', serif",
          transition: "none",
          fontSize: "12px",
          padding: "8px",
          shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
          zIndex: 99999,
        },
        shadow: true,
        useHTML: true,
        outside: true,
      },
      plotOptions: {
        series: {
          states: {
            hover: {
              enabled: false,
            },
          },
          borderWidth: 0,
          column: {
            stacking: "percent",
            borderWidth: 0.3,
            borderRadius: 8,
          },
          dataLabels: {
            enabled: true,
            format: "{point.y:.2f}",
            style: {
              color: "#555555",
              cursor: "pointer",
              border: "none",
              fontWeight: 500,
              fontSize: "12px",
              fontFamily: "'Roboto Flex', serif",
              textDecoration: "none",
            },
          },
        },
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: "Categories",
          colorByPoint: false,
          data: seriesData,
        },
      ],
      drilldown: {
        series: drilldownSeries,
        activeAxisLabelStyle: {
          color: "#555555",
          cursor: "pointer",
          fontWeight: "normal",
          fontSize: "11px",
          fontFamily: "'Roboto Flex', serif",
          textDecoration: "none",
        },
        activeDataLabelStyle: {
          color: "#555555",
          cursor: "pointer",
          border: "none",
          fontWeight: 500,
          fontSize: "12px",
          fontFamily: "'Roboto Flex', serif",
          textDecoration: "none",
        },
        breadcrumbs: {
          buttonSpacing: 5,
          buttonTheme: {
            style: {
              color: "#555555",

              fontFamily: "'Roboto Flex', serif",
              fontSize: "12px",
              textDecoration: "none",
              position: {
                align: "left",
                verticalAlign: "top",
              },
            },
          },
        },
      },
    });
  }, [data]);

  return (
    <div
      className="bg-white p-4 "
      style={{ border: "none", borderRadius: "8px", margin: "0px 20px" }}
    >
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default DrilldownChart;
